document.addEventListener('click', (event) => {
  const link = event.target.closest('a[href^="#"]');

  if (!link) return;

  const targetId = link.getAttribute('href');

  // Ignore empty hash links
  if (!targetId || targetId === '#') return;

  const targetFaq = document.querySelector(targetId);

  // Only handle links pointing to FAQ sections
  if (!targetFaq || !targetFaq.closest('.faq')) return;

  event.preventDefault();

  // Close all other open FAQ toggles
  document.querySelectorAll('.faq toggle-tab.opened').forEach((toggle) => {
    if (!targetFaq.contains(toggle)) {
      toggle.onClickHandler();
    }
  });

  // Open the target FAQ
  const targetToggle = targetFaq.querySelector('toggle-tab');

  if (targetToggle && !targetToggle.classList.contains('opened')) {
    targetToggle.onClickHandler();
  }

  // Scroll to the FAQ
  setTimeout(() => {
  targetFaq.scrollIntoView({
    behavior: 'smooth',
    block: 'start'
  });
}, 250);

  // Keep the URL hash updated
  history.pushState(null, '', targetId);
});